import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Loading from "../../../components/__common/Loading/Loading";
import { URLS } from "../../../constants/urls";
import { useAuthProvider } from "../../../hooks/useAuthProvider";
import { useQuery } from "../../../hooks/query-hooks";
import { ApplicationState } from "../../../store";
import { UserState } from "../../../store/reducers/user-reducer";
import { useHistory } from "react-router-dom";
import { deepLinkService } from "../../../deeplink/DeepLinkService";

export const Login: React.FC = () => {
  const query: any = useQuery();
  const { login } = useAuthProvider();
  const history = useHistory();
  const userState = useSelector<ApplicationState, UserState>(
    (state) => state.user
  );

  useEffect(() => {
    const body = document.body;
    body.classList.add("modal-open");

    return () => {
      body.classList.remove("modal-open");
    };
  });

  useEffect(() => {
    if (!userState.isGeoIPLoading) {
      // Check if there's a pending deeplink in localStorage (saved by DeepLinkChecker)
      const pendingDeepLink = deepLinkService.get();

      let redirectUri = query.get("redirect");

      if (redirectUri?.includes(URLS.OLD_MYDATA)) {
        redirectUri = URLS.MYDATA;
      }

      // Prefer the authRedirect from deeplink over the query param
      // This ensures the deeplink with ticket survives the SA redirect
      if (pendingDeepLink?.authRedirect) {
        login("SA", { redirectURL: pendingDeepLink.authRedirect });
      } else if (!redirectUri) {
        localStorage.setItem("hasAccessLoginThruDeepLinked", "true");
        history.push("/");
      } else {
        login("SA", { redirectURL: redirectUri });
      }
    }
  }, [userState.isGeoIPLoading]);

  return <Loading />;
};
